import React from 'react';
import PropTypes from 'prop-types';

import { mixins } from '../../../styles';
import UserRegisterFormContainer from '../../../containers/UserRegisterFormContainer';

import Button from '../../ui/Button';
import CheckboxButton from '../../ui/CheckboxButton';
import Popover from '../../ui/Popover';
import Spinner from '../../ui/Spinner';
import TaraHeader from './TaraHeader';
import TaraPopoverFooter from './TaraPopoverFooter';
import TaraQuestion from './TaraQuestion';
import TaraText from './TaraText';

const noop = () => {};

const DefaultTaraMessage = () => (
  <div>
    <div>Hi there!</div>
    <div>
      <span>To get started, can I ask you a few questions to get to know <em>you</em> better?</span>
    </div>
  </div>
);

const IntroductionTaraMessage = () => (
  <div>
    <div>
    Hi there, I&apos;m <strong>TARA</strong>, and I'll be assisting you with your ticket purchase.
    </div>
    <div>
      <span>To get started, can I ask you a few questions to get to know <em>you</em> better?</span>
    </div>
  </div>
);

const styleButton = {
  height: 48,
  width: '100%',
};

const styleTaraHeader = {
  marginBottom: 32,
};

const styleSpaced = {
  marginBottom: 16,
};

const HEADER_HEIGHT = 56;
const SPACING = 32;
const QUESTION_SCROLL_OFFSET = HEADER_HEIGHT + SPACING;

const SUCCESS_TEXT = (
  <div>
    <div>Thanks for that, I'll find tickets with you're preferences in mind!</div>
  </div>
);

class TaraSurvey extends React.PureComponent {
  static propTypes = {
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    taraSetHasMadeIntroduction: PropTypes.func,

    survey: PropTypes.shape({
      surveyId: PropTypes.number,
      siteId: PropTypes.number,
      questionList: PropTypes.arrayOf(PropTypes.shape({
        questionText: PropTypes.string,
        questionId: PropTypes.number,
        sortOrder: PropTypes.number,
        answerList: PropTypes.arrayOf(PropTypes.shape({
          answerText: PropTypes.string,
          answerId: PropTypes.number,
          sortOrder: PropTypes.number,
        })),
      })),
    }),

    hasButton: PropTypes.bool,
    hasMadeIntroduction: PropTypes.bool,
    isAnimated: PropTypes.bool,
    isOpen: PropTypes.bool,
  };

  static defaultProps = {
    taraSetHasMadeIntroduction: noop,
    onCancel: noop,
    onSubmit: noop,

    hasButton: false,
    hasMadeIntroduction: false,
    isAnimated: false,
    isOpen: undefined,
  };

  static ANIMATION_DURATION_MS = 800;

  state = {
    answersByQuestionId: {},
    currentQuestionIndex: 0,
    hasFinishedSurvey: false,
    hasSubmitted: false,
    isQualified: false,
    isReady: false,
    isRegistering: false,
    rejectedRegister: false,
  };

  popoverScrollRef = null;
  questionRefs = [];

  componentDidMount() {
    this.hasMounted = true;

    setTimeout(() => {
      this.setIsReady(true);
    }, 1600);
  }

  componentWillReceiveProps(nextProps) {
    const {
      hasMadeIntroduction,
      status,
    } = nextProps;

    const isChangingHasMadeIntroduction = hasMadeIntroduction !== this.props.hasMadeIntroduction;
    const isChangingStatus = status !== this.props.status;

    if (isChangingHasMadeIntroduction || isChangingStatus) {
      this.taraMessage = this.getTaraMessage(nextProps);
    }
  }

  componentWillUnmount() {
    this.hasMounted = false;
  }

  taraMessage = this.getTaraMessage(this.props);

  getTaraMessage(props) {
    const {
      hasMadeIntroduction,
      isQualified,
      status,
    } = props;

    if (!hasMadeIntroduction) {
      this.props.analyticsRecordActionRequest('tara','introduction', '');
    }

    if (status === 'REQUEST') {
      return null;
    }

    if (status === 'SUCCESS') {
      return SUCCESS_TEXT;
    }

    return hasMadeIntroduction ?
      (<DefaultTaraMessage />)
      :
      (<IntroductionTaraMessage />);
  }

  setAnswer = (questionId, answerId) => {
    const {
      answersByQuestionId,
      currentQuestionIndex,
      hasFinishedSurvey,
    } = this.state;

    const existingAnswer = answersByQuestionId[questionId];
    const { length } = this.props.survey.questionList;

    const nextQuestionIndex = !existingAnswer ? (currentQuestionIndex + 1) : currentQuestionIndex;

    this.setState({
      currentQuestionIndex: nextQuestionIndex,
      answersByQuestionId: {
        ...this.state.answersByQuestionId,
        [questionId]: !existingAnswer ? answerId : null,
      },

      hasFinishedSurvey: hasFinishedSurvey ? true : (currentQuestionIndex === length - 1),
    });

    setTimeout(() => this.scrollToQuestion(nextQuestionIndex), 300);
  };

  setIsReady = (isReady) => {
    if (this.hasMounted) {
      this.setState({ isReady });
    }
  };

  setPopoverScrollRef = ref => this.popoverScrollRef = ref;
  setQuestionRef = index => ref => this.questionRefs[index] = ref;

  scrollToQuestion = (index) => {
    if (this.questionRefs[index] && this.questionRefs[index].offsetTop) {
      const top = this.questionRefs[index].offsetTop - QUESTION_SCROLL_OFFSET;
      this.popoverScrollRef.scrollTo({ top, behaviour: 'smooth' });
    }
  };

  createHandleClick = (question, answer) => () => {
    this.setAnswer(question.questionId, answer.answerId);
    this.props.analyticsRecordActionRequest('survey','answer', this.state.currentQuestionIndex);
  };

  handleClickYes = () => {
    this.setState({
      isQualified: true,
      hasSubmitted: false,
      hasFinishedSurvey: false,
      answersByQuestionId: {},
      currentQuestionIndex: 0,
    });

    this.props.analyticsRecordActionRequest('survey','start', '');
    this.props.onStart();
  };

  handleCancel = (e) => {
    const form = {
      survey: this.props.survey,
      answers: this.state.answersByQuestionId,
    };

    this.props.analyticsRecordActionRequest('survey','cancel', '');
    this.props.onCancel(e, form);
  };

  handleClickYesRegister = () => {
    this.setState({
      isRegistering: true,
      rejectedRegister: false,
    });
  };

  handleCancelRegister = (e) => {
    this.setState({
      isRegistering: false,
      rejectedRegister: true,
    });
  };

  handleSubmit = (e) => {
    const form = {
      survey: this.props.survey,
      answers: this.state.answersByQuestionId,
    };

    this.props.onSubmit(e, form);

    this.setState({
      hasSubmitted: true,
    });
  };

  renderFooter() {
    if (!this.state.hasFinishedSurvey && !this.state.hasSubmitted) {
      return null;
    }

    return (
      <TaraPopoverFooter>
        <Button
          color="accent"
          label="Submit"
          isRaised
          onClick={this.handleSubmit}
          style={styleButton}
        />
      </TaraPopoverFooter>
    );
  }

  renderPopoverOpen = (this.props.hasButton ? handleOpen => (
    <Button onClick={handleOpen}>
      Tara Survey
    </Button>
  ) : null);

  renderRegisterQuestion() {
    return (
      <div>
        <TaraText
          hasNoDelay
          isQuestion
          isAnimated
        >
          Would you like me to remember you the next time you visit?
        </TaraText>
        <TaraPopoverFooter>
          <Button
            color="accent"
            label="Yes"
            isRaised
            onClick={this.handleClickYesRegister}
            style={styleButton}
          />
          <Button
            className="LeftButton"
            color="primary"
            label="No Thanks"
            onClick={this.handleCancelRegister}
            style={styleButton}
          />
        </TaraPopoverFooter>
      </div>
    );
  }

  renderQualifier() {
    if (this.props.status === 'SUCCESS' && !this.props.userId && !this.state.rejectedRegister) {
      return this.renderRegisterQuestion();
    }

    return (
      <div>
        {this.state.hasFinishedSurvey && (
          <TaraText
            hasNoDelay
            isQuestion
            isAnimated
          >
            Do you want to answer the questions again?
          </TaraText>
        )}
        <TaraPopoverFooter>
          <Button
            color="accent"
            label="Yes"
            isRaised
            onClick={this.handleClickYes}
            style={styleButton}
          />
          <Button
            className="LeftButton"
            color="primary"
            label="No Thanks"
            onClick={this.handleCancel}
            style={styleButton}
          />
        </TaraPopoverFooter>
      </div>
    );
  }

  renderQualifiedText() {
    return (
      <TaraText
        hasNoDelay
        isQuestion
        isAnimated
      >
        Great! It&apos;s only a few questions, so let&apos;s jump right in!
      </TaraText>
    );
  }

  renderQuestion = (question, index) => {
    const {
      answersByQuestionId,
      currentQuestionIndex,
    } = this.state;

    if (currentQuestionIndex < index) {
      return null;
    }

    const {
      questionId,
      questionText,
    } = question;

    const existingAnswer = answersByQuestionId[questionId];

    const renderAnswer = (answer, index) => (!existingAnswer || existingAnswer === answer.answerId) ? (
      <CheckboxButton
        key={answer.answerText}
        color={existingAnswer === answer.answerId ? 'primary' : undefined}
        label={answer.answerText}
        isChecked={existingAnswer === answer.answerId}
        onClick={this.createHandleClick(question, answer)}
        style={(index !== question.answerList.length - 1) && styleSpaced}
      />
    ) : null;

    return (
      <TaraQuestion
        key={questionId}
        id={questionId}
        text={questionText}
        isAnimated={this.props.isAnimated}
        isCollapsed={!!answersByQuestionId[questionId]}
        questionRef={this.setQuestionRef(index)}
      >
        {question.answerList.map(renderAnswer)}
      </TaraQuestion>
    );
  };

  renderQuestions() {
    return this.props.survey.questionList.map(this.renderQuestion);
  }

  renderScreen() {
    return (
      <div style={{ position: 'absolute', ...mixins.fillToParent, background: 'rgba(255,255,255,0.87)'}}>
        <Spinner isReady={!this.props.isFetching} />
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <TaraText
          hasNoDelay
          isQuestion
          isAnimated
        >
          {SUCCESS_TEXT}
        </TaraText>
        {this.renderQualifier()}
      </div>
    );
  }

  renderSurvey() {
    const {
      isQualified,
      isReady,
    } = this.state;

    return (
      <div>
        {!isQualified && this.renderQualifier()}
        {isQualified && this.renderQualifiedText()}
        {isReady && isQualified && this.renderQuestions()}

        {this.renderFooter()}
      </div>
    );
  }

  render() {
    return (
      <Popover
        onCancel={this.handleCancel}
        renderOpen={this.renderPopoverOpen}
        isOpen={this.props.isOpen}
        hasOk={false}
        popoverScrollRef={this.setPopoverScrollRef}
        popoverWidth={480}
        closeOnClickBackdrop={this.props.canDismiss}
      >
        <TaraHeader
          isAnimated
          message={this.taraMessage}
          style={styleTaraHeader}
        />

        {this.state.isQualified && this.state.hasSubmitted ? this.renderQualifier() : this.renderSurvey()}
        {this.state.isRegistering && (<UserRegisterFormContainer />)}
        {this.props.isFetching && this.renderScreen()}
      </Popover>
    );
  }
}

export default TaraSurvey;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraSurvey.js